<p-floatlabel [variant]="variant" class="input-field">
  <p-select
    [inputId]="id"
    [options]="options"
    [formControl]="control"
    [checkmark]="true"
    optionLabel="displayValue"
    optionValue="id"
    [showClear]="showClear()"
    [fluid]="true"
    [class.ng-invalid]="control.invalid && control.touched"
    [class.ng-dirty]="control.touched"
    (onChange)="changed.emit($event.value)"
  />
  @if (hasLabel()) {
    <label [for]="id">{{ label }}</label>
  }
</p-floatlabel>
@if (control.invalid && control.touched) {
  <small class="input-field__error">{{ errorMessage ?? 'This field is required' }}</small>
}
